import { Oura } from '@jouzen/ecom-components/icons/Oura';
import { ShoppingCart } from '@jouzen/ecom-components/layout';
import { cx } from 'class-variance-authority';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { useCallback } from 'react';

import { GEN3_POP_PATHNAME } from '@/app/consts/pathnames';

import Tabs from './Tabs';
import type { HeaderProps } from './types';
import VariantLabel from './VariantLabel';

const DesktopHeader = ({
  hasEyebrow,
  inverseHeader,
  isAccessory,
  itemCountForIcon,
}: HeaderProps) => {
  const t = useTranslations();
  const locale = useLocale();
  const router = useRouter();
  const basePopPath = isAccessory ? '/store' : GEN3_POP_PATHNAME;

  const handleShoppingCartClick = useCallback(() => {
    router.push(`/${locale}/cart`);
  }, [locale, router]);

  return (
    <header
      className="fixed z-20 w-full"
      style={{ top: hasEyebrow ? '3rem' : '0' }}
    >
      <div className="flex w-full justify-between">
        <Link
          aria-label={t('pdp_back_to_pop')}
          className={cx('block py-6 pl-4', {
            'text-sandstone-200': inverseHeader,
            'text-sandstone-500': !inverseHeader,
          })}
          data-cy="nav_logo_link"
          href={basePopPath}
        >
          <Oura width={80} />
        </Link>
        <div className="flex">
          <div className="flex items-center">
            <VariantLabel inverseHeader={inverseHeader} />
            <ShoppingCart
              hiddenHamburger={false}
              inverseHeader={inverseHeader ?? false}
              onShoppingCartClick={handleShoppingCartClick}
              shoppingCartCount={itemCountForIcon ?? 0}
            />
          </div>
          <div className="flex w-[31rem] border-b border-gray-300">
            <Tabs />
          </div>
        </div>
      </div>
    </header>
  );
};

export default DesktopHeader;
